import { useContext } from "react";
import { ToastContext } from "../contexts/index";

export default function useToast() {
  const toastHelpers = useContext(ToastContext);

  return toastHelpers;
}
